export default __webpack_public_path__ + "static/media/Nergal's Trident of the Eternal Storm.63f3f38b.jpg";